import React from 'react';
import { useNavigate } from 'react-router-dom';
import LayoutWrapper from '../components/LayoutWrapper';
import {
  UserGroupIcon,
  BuildingOfficeIcon,
  ExclamationTriangleIcon,
  BanknotesIcon,
} from '@heroicons/react/24/outline';

const Reports = () => {
  const navigate = useNavigate();

  const reportCards = [
    {
      title: 'User Attendance',
      description: 'View detailed attendance history, tokens spent, and session time for individual users',
      icon: UserGroupIcon,
      color: 'bg-blue-500',
      path: '/dashboard/reports/user-attendance'
    },
    {
      title: 'Venue Attendance',
      description: 'Overview of all sessions, attendance patterns by time and date across your venue',
      icon: BuildingOfficeIcon,
      color: 'bg-indigo-500',
      path: '/dashboard/reports/venue-attendance'
    },
    {
      title: 'Users at Risk',
      description: 'Identify users with low attendance and declining engagement to re-engage and retain',
      icon: ExclamationTriangleIcon,
      color: 'bg-red-500',
      path: '/dashboard/reports/users-at-risk'
    },
    {
      title: 'Sign up health',
      description: 'Members who started setting up a Direct Debit and never finished, and how your invitations turned out',
      icon: UserGroupIcon,
      color: 'bg-amber-500',
      path: '/dashboard/reports/sign-ups'
    },
    {
      title: 'Token History',
      description: 'Comprehensive token transaction reporting with filters by user, category, and date range',
      icon: BanknotesIcon,
      color: 'bg-green-500',
      path: '/dashboard/reports/token-history'
    },
    // {
    //   title: 'Class Analytics',
    //   description: 'Analyze class performance, attendance rates, and popular time slots',
    //   icon: ChartBarIcon,
    //   color: 'bg-purple-500',
    //   path: '#',
    //   disabled: true
    // },
    // {
    //   title: 'Revenue Reports',
    //   description: 'Track revenue, payments, and subscription trends',
    //   icon: CalendarIcon,
    //   color: 'bg-green-500',
    //   path: '#',
    //   disabled: true
    // },
    // {
    //   title: 'Time Analysis',
    //   description: 'Understand peak hours and session utilization',
    //   icon: ClockIcon,
    //   color: 'bg-orange-500',
    //   path: '#',
    //   disabled: true
    // }
  ];

  return (
    <LayoutWrapper
      title="Reports"
      subtitle="Analytics and insights for your venue"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
        {reportCards.map((report, index) => (
          <div
            key={index}
            onClick={() => !report.disabled && navigate(report.path)}
            className={`card p-6 transition-all duration-200 ${
              report.disabled
                ? 'opacity-50 cursor-not-allowed'
                : 'cursor-pointer hover:border-primary-500 hover:shadow-lg'
            }`}
          >
            <div className="flex items-start space-x-4">
              <div className={`flex-shrink-0 w-12 h-12 ${report.color} rounded-lg flex items-center justify-center`}>
                <report.icon className="h-6 w-6 text-white" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-white mb-2">
                  {report.title}
                  {report.disabled && (
                    <span className="ml-2 text-xs text-gray-500 font-normal">(Coming Soon)</span>
                  )}
                </h3>
                <p className="text-sm text-gray-400">
                  {report.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </LayoutWrapper>
  );
};

export default Reports;
